document.addEventListener('alpine:init', () => {

    /**
     * Object to manage the ability of dispute form options to prevent adding contradicting disputes (duplicates).
     *
     * @property {number} index form index
     * @property {string} selectedService value of selected service
     * @property {string} selectedServiceItem value of selected service item
     * @property {number} selectedCase value of selected case related to service item
     * @property {object} dispute instance of dispute MSA resource
     * @property {object} serviceItems object of service items list
     * @property {string} serviceCode code of dispute service
     * @property {array} hiddenSelectors array of hidden options by CSS selectors
     */
    Alpine.data('disputeItemForm', (
        index,
        selectedService,
        selectedServiceItem,
        selectedCase,
        dispute,
        serviceItems,
        serviceCode
    ) => ({
        index: index,
        selectedService: selectedService,
        selectedServiceItem: selectedServiceItem,
        selectedCase: selectedCase,
        dispute: dispute,
        serviceItems: serviceItems,
        serviceCode: serviceCode,
        hiddenSelectors: [],

        init() {
            this.$watch('dispute', () => this.reHideTakenOptions());
            this.hideTakenOptions();
        },

        /**
         * Hide elements by CSS selector.
         *
         * @param selector
         */
        hideSelector(selector) {
            try {
                document.querySelectorAll(selector).forEach(element => {
                    element.style.display = 'none';
                });
                this.hiddenSelectors.push(selector);
            } catch (e) {
            }
        },

        /**
         * Show back all hidden elements before.
         */
        showHiddenSelectors() {
            if (!this.hiddenSelectors.length) {
                return;
            }
            try {
                document.querySelectorAll(this.hiddenSelectors).forEach(element => {
                    element.style.display = null;
                });
                this.hiddenSelectors = [];
            } catch (e) {
            }
        },

        /**
         * Hide options of taken services, items, and cases.
         */
        hideTakenOptions() {
            for (const dispute of this.dispute.disputes) {
                const leftServiceItems = this.getLeftServiceItems(
                    dispute.service,
                    this.getTakenServiceIds(),
                    this.getTakenCaseNumbers()
                );
                if (!leftServiceItems.length && dispute.service !== this.selectedService) {
                    this.hideService(dispute.service);
                }
                if (!this.getServiceItemIds(leftServiceItems).includes(Number(dispute.serviceId))
                    && dispute.serviceId !== this.selectedServiceItem) {
                    this.hideServiceItem(dispute.serviceId);
                }
                if (dispute.caseNumber && dispute.caseNumber !== this.selectedCase) { // CHANGED
                    this.hideCase(dispute.caseNumber);
                }
            }
        },

        /**
         * Hide element of case.
         *
         * @param {number} caseNumber
         */
        hideCase(caseNumber) {
            this.hideSelector(`.${this.index}-dispute-case-${caseNumber}`);
        },

        /**
         * Hide element of service item.
         *
         * @param {string} serviceId
         */
        hideServiceItem(serviceId) {
            this.hideSelector(`.${this.index}-dispute-service-item-${serviceId}`);
        },

        /**
         * Hide element of service.
         *
         * @param {string} serviceCode
         */
        hideService(serviceCode) {
            this.hideSelector(`.${this.index}-dispute-service-${serviceCode}`);
        },

        /**
         * Get identifiers array of services.
         *
         * @param {array} serviceItems
         * @return {number[]}
         */
        getServiceItemIds(serviceItems) {
            return serviceItems.map(item => item.serviceId);
        },

        /**
         * Get array of services not taken of existence disputes.
         *
         * @param {string} takenServiceCode
         * @param {number[]} takenServiceIds
         * @param {(number|null)[]} takenCaseNumbers
         * @return {object[]}
         */
        getLeftServiceItems(takenServiceCode, takenServiceIds, takenCaseNumbers) {
            const leftServiceItems = [];
            for (const key in this.serviceItems ) {
                const serviceItem = this.serviceItems[key];

                if (serviceItem['serviceCode'] === Number(takenServiceCode)) {
                    if (serviceItem.items) {
                        // Check if there are any case numbers left
                        const leftCaseNumbers = serviceItem.items.filter(
                            item => item.itemType === 'CASE' && !takenCaseNumbers.includes(item.itemId)
                        );
                        if (leftCaseNumbers.length) {
                            leftServiceItems.push(this.serviceItems[key]);
                        }
                        // No case numbers. Check if service item has been taken by any dispute
                    } else if(!takenServiceIds.includes(serviceItem['serviceId'])) {
                        leftServiceItems.push(this.serviceItems[key]);
                    }
                }
            }

            return leftServiceItems;
        },

        /**
         * Get array of services identifiers taken of existence disputes.
         *
         * @return {number[]}
         */
        getTakenServiceIds() {
            return this.dispute.disputes.map((dispute) => Number(dispute.serviceId));
        },

        /**
         * Get array of case numbers taken of existence disputes.
         *
         * @return {(number|null)[]}
         */
        getTakenCaseNumbers() {
            return this.dispute.disputes.map((dispute) => dispute.caseNumber);
        },

        /**
         * Reset hidden options and hide needed.
         */
        reHideTakenOptions() {
            this.showHiddenSelectors();
            this.hideTakenOptions();
        },
    }));
});